// apiService.js
import { API_PASSWORD } from '../../config';
import { getSubdomain, fetchWithAuth } from '../../helpers';
import { getToken } from '../../helpers';


// جلب إعدادات الخدمات والضرائب
export const fetchServiceAndTaxSettings = async () => {
  
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const url = `https://${subdomain}.restocash.app/api/get/settings?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    
    throw new Error(data.message || "❌ فشل في جلب إعدادات الخدمات والضرائب.");
  }

  console.log("🔥 البيانات:", data);
  return data.data?.settings?.[0] || {};

};

// جلب إعدادات شرائح التوصيل
export const fetchDeliverySettings = async () => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const url = `https://${subdomain}.restocash.app/api/get/delivery/setting?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب إعدادات شرائح التوصيل.");
  }

  return data.data?.setting || [];
};

// حفظ إعدادات الخدمات والضرائب , الجلسات والوردية
export const saveServiceAndTaxSettingsAndSessions = async (settingsData) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/save/general/setting?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(settingsData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في حفظ إعدادات الخدمات والضرائب.");
  }

  return data;
};

// حفظ شريحة توصيل جديدة
export const saveDeliverySetting = async (deliveryData) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/add/delivery/setting?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(deliveryData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في حفظ شريحة التوصيل.");
  }

  return data;
};

// تعديل شريحة توصيل
export const editDeliverySetting = async (id, deliveryData) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/edit/delivery/setting/${id}?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(deliveryData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تعديل شريحة التوصيل.");
  }

  return data;
};

// إضافة دالة تعديل زمن الحجز
export const editReservationTime = async (reservationTimeInMinutes) => {
	// reservationTimeInMinutes متوقع رقم (دقائق)
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/reservatio/time?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("reservation_time", String(reservationTimeInMinutes));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type لأن المتصفح يحدده تلقائياً عند استخدام FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل زمن الحجز.");
	}

	return data;
};

